import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import {
  getFormValues
} from 'redux-form';
import _ from 'lodash';
import {
  LOAD_CONTENT,
  DISCONNECT_CUSTOMER,
  DL_PAGE_LOADED
} from './cancel';
import {
  SET_DATA,
  customerSelector
} from '../../../data/customer/customer';
import loader from '../../../../../util/loader/loader';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';

// WATCHERS
export function* loadCustomerWatch() {
  yield takeLatest(LOAD_CONTENT, loadCustomerWorker);
}

export function* disconnectWatch() {
  yield takeLatest(DISCONNECT_CUSTOMER, disconnectWorker);
}

// WORKERS
export function* loadCustomerWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true}));

    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());
  } catch(e) {
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.movers.ERROR].path);
  }
}

export function* disconnectWorker() {
  try {
    const errorPage = yield select(errorPageByFlow);
    const values = yield select(getFormValues('cancel'));
    const customer = yield select(customerSelector);
    const data = {
      disconnectDate: values.serviceStopDate
    };

    const postLoad = function* () {
      const customerWithUpdates = {
        customer: {
          ...customer,
          serviceStopDate: _.get(data, 'disconnectDate')
        }
      };

      yield put({
        type: SET_DATA,
        payload: customerWithUpdates
      });
    };

    const endpoint = navigationRoutes[navigationSteps.movers.CANCEL].endpoints.disconnectCustomer();

    const success = yield call(loader.request, endpoint, {data, hideContentWhileLoading: false, postLoad, postLoadOnError: false, errorPage});

    if (!success) {
      return;
    }
  } catch(e) {
    //console.log(e)
  }
}

export default function* moversCancelSagas() {
  yield [
    fork(loadCustomerWatch),
    fork(disconnectWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/cancel/cancelSagas.js
 **/